// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#stat-link{cursor:pointer;color:#525f7f!important}.no-credit-report{background-color:#ff2e55}.text .h2,.text h5{color:#fff!important}.text{color:#fff}.text-header{color:#333}", ""]);
// Exports
module.exports = exports;
